(ns story-builder.util.js
  (:require
   [clojure.string :as str]))

(defn stringify-js-object [o]
  (letfn [(->js [x]
            (cond
              (and (object? x) (not (array? x)))
              (str "{"
                   (clojure.string/join
                    ", "
                    (for [k (js/Object.keys x)]
                      (str k ": " (->js (aget x k)))))
                   "}")

              (array? x)
              (str "["
                   (clojure.string/join ", " (map ->js (array-seq x)))
                   "]")

              (string? x)
              (str "\"" x "\"")

              :else
              (str x)))]
    (->js o)))